import React from "react";
import { Container, Row, Col } from "reactstrap";
import DetailShareTools from "./DetailShareTools";
import RecommendDR from '../../sections/RecommendDR/RecommendDR';
import './Detail.css';
import { useParams } from 'react-router-dom';
import { Helmet } from "react-helmet";


function withParams(Component) {
    return (props) => <Component {...props} params={useParams()} />;
}


class Detail extends React.Component {

    constructor(props) {
        super(props);
        this.state =
        {
            isLoading: true,
            isError: false,
            contentDetail: {}
        };
    }

    async getTargetAnnouncement(contentType, slug) {
        try {
            var url = 'api/Content/GetContentBySlug?contentType=' + contentType + '&slug=' + slug;
            const response = await fetch(url);
            const data = await response.json();
            this.setState({ contentDetail: data, isLoading: false });
        }
        catch {
            this.setState({ isError: true });
        }
    }

    async componentDidMount() {
        var { contentType, slug } = this.props.params;
        await this.getTargetAnnouncement(contentType, slug);
    }

    async componentDidUpdate(preProps) {

        var { contentType, slug } = this.props.params;
        if (contentType !== preProps.params.contentType || slug !== preProps.params.slug) {
            await this.getTargetAnnouncement(contentType, slug);
        }
    }

    static formatDateTime(datetimeString) {
        const date = new Date(datetimeString);
        const day = date.getUTCDate().toString().padStart(2, '0');
        const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
        const year = date.getUTCFullYear();
        return `${day}/${month}/${year}`;
    }

    static renderDetailPage(contentDetail, contentType) {
        var { title, htmlContent } = contentDetail;

        return <Container id="detail-page">
            <Helmet>
                <title>{`${title}`}</title>
                <meta name="description" content={title} />
            </Helmet>
            <Row>
                <div style={{width: '1px',height: '40px'} }></div>
            </Row>
            <Row>
                <Col>
                    <h2 className="title-detail-page">{title}</h2>
                    <hr />
                </Col>
            </Row>
            <DetailShareTools contentType={contentType} updatedAt={this.formatDateTime(contentDetail.updatedAt)} />
            <Row>
                <Col>
                    <div style={{ maxWidth: '90%', margin: '0 auto' }}>
                        <div className="detail-body">
                            <div>
                                <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                {(contentDetail.pdfFileLinkForIFrame !== null && contentDetail.pdfFileLinkForIFrame !== "")
                    ? <iframe
                        title="PDF Preview"
                        width="80%"
                        height="700px"
                        src={contentDetail.pdfFileLinkForIFrame}
                        frameBorder="0"
                    ></iframe>
                    : <></>}
                <div style={{ width: '1px', height: '50px' }}></div>
            </Row>
            <Row>
                <RecommendDR />
                <div style={{ width: '1px', height: '50px' }}></div>
            </Row>
        </Container>
    }

    render() {
        var { contentType } = this.props.params;
        if (this.state.isError) {
            return <p><em>Sorry, something went wrong. Please try again later</em></p>;
        } else {
            if (this.state.isLoading) {
                return <p><em>Loading...</em></p>;
            } else {
                // the data is ready at this point
                return Detail.renderDetailPage(this.state.contentDetail, contentType);
            }
        }
    }

}


export default withParams(Detail);